import React, { useMemo, useState } from "react";
import { Badge, Flex, Select } from "@chakra-ui/react";
import { BaseStatus } from "constants/invoice";
import { CloseIcon, EditIcon } from "@chakra-ui/icons";

interface StatusDisplayProps {
  status: string;
  configuration?: Record<string, BaseStatus>;
  options?: Record<string, string>;
  onUpdate?: (status: string) => void;
}

function StatusDisplay({
  status,
  configuration,
  options,
  onUpdate,
}: StatusDisplayProps) {
  const [isEditing, setEditing] = useState(false);

  const { name, backgroundColor, textColor } = useMemo(() => {
    const foundConfiguration = configuration?.[status.toLowerCase()];
    return foundConfiguration
      ? foundConfiguration
      : { name: status, textColor: "gray.900", backgroundColor: "gray.200" };
  }, [status, configuration]);

  return (
    <Flex gap={2} alignItems="center">
      {isEditing ? (
        <Flex gap={2}>
          {options && (
            <Select
              value={status}
              size="sm"
              onChange={(e) => {
                if (e.target.value === "") return;
                onUpdate && onUpdate(e.target.value);
                setEditing(false);
              }}
            >
              <option value="">Select an option</option>
              {Object.entries(options).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
            </Select>
          )}
        </Flex>
      ) : (
        <Badge backgroundColor={backgroundColor} textColor={textColor}>
          {name}
        </Badge>
      )}
      {onUpdate && options ? (
        isEditing ? (
          <CloseIcon
            cursor={"pointer"}
            boxSize={3}
            ml={2}
            onClick={() => setEditing(false)}
          />
        ) : (
          <EditIcon
            cursor={"pointer"}
            boxSize={3}
            ml={2}
            onClick={() => setEditing(true)}
          />
        )
      ) : (
        <></>
      )}
    </Flex>
  );
}

export default StatusDisplay;
